import http from "./http-auth";

export function sendMailtoNoemi(data) {
  return http.post("/sendMailNoemi", data).then((res) => {});
}

export function sendMailtoManager(data) {
  return http.post("/sendMailManager", data).then((res) => {});
}
